import {
  ResponsiveContainer,
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
} from "recharts";
import { revenueSeries } from "@/mocks/seed";

export function RevenueChart() {
  return (
    <ResponsiveContainer width="100%" height={200}>
      <AreaChart data={revenueSeries} margin={{ top: 8, right: 8, left: -10, bottom: 0 }}>
        <defs>
          <linearGradient id="revGrad" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#6d7cff" stopOpacity={0.25} />
            <stop offset="100%" stopColor="#6d7cff" stopOpacity={0} />
          </linearGradient>
          <linearGradient id="profitGrad" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#22c87a" stopOpacity={0.2} />
            <stop offset="100%" stopColor="#22c87a" stopOpacity={0} />
          </linearGradient>
        </defs>
        <CartesianGrid stroke="rgba(255,255,255,0.04)" vertical={false} />
        <XAxis dataKey="month" tick={{ fill: "#4a4e62", fontSize: 10 }} axisLine={false} tickLine={false} />
        <YAxis
          tick={{ fill: "#4a4e62", fontSize: 10 }}
          axisLine={false}
          tickLine={false}
          tickFormatter={(v: number) => `${(v / 1000).toFixed(0)}k`}
        />
        <Tooltip
          contentStyle={{ background: "#171d2a", border: "1px solid rgba(226,232,255,0.13)", borderRadius: 11, fontSize: 12 }}
          labelStyle={{ color: "#e8eaf2" }}
        />
        <Area type="monotone" dataKey="revenue" stroke="#6d7cff" strokeWidth={2} fill="url(#revGrad)" name="Revenu" />
        <Area type="monotone" dataKey="profit" stroke="#22c87a" strokeWidth={2} fill="url(#profitGrad)" name="Bénéfice" />
      </AreaChart>
    </ResponsiveContainer>
  );
}
